<template>
  <nav class="navbar is-primary" v-if="user && (user.is_staff || user.is_evaluator)">
    <div class="container">
      <div class="navbar-brand">
        <span class="navbar-item"
          ><h5 class="title is-5 has-text-white-bis">
            Unfunded List<span v-if="user && user.is_staff && user.is_evaluator"> Staff Portal</span>
          </h5></span
        >
      </div>
      <div class="navbar-start">
        <!-- Evaluator Section -->
        <router-link :to="{ name: 'ApplicationReview' }" class="navbar-item" v-if="user && user.is_evaluator"
          >Your Assignments</router-link
        >
        <a href="https://www.unfundedlist.com/donations/" target="_blank" class="navbar-item">
          Donate to Unfunded List&nbsp;<i class="fa fa-external-link"></i>
        </a>
        <router-link
          :to="{ name: 'EvaluationsOverview' }"
          class="navbar-item"
          v-if="user && user.is_staff && user.is_evaluator"
          >Assignments Overview</router-link
        >
        <div class="navbar-item has-dropdown is-hoverable" v-if="user && user.is_staff && user.is_evaluator">
          <a class="navbar-link">
            Evaluators
          </a>

          <div class="navbar-dropdown">
            <!-- Staff Section -->

            <router-link
              :to="{ name: 'EvaluatorsOverview' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Evaluators</router-link
            >
            <router-link
              :to="{ name: 'EvaluatorsStatusOverview' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Evaluators By Status</router-link
            >

            <router-link
              :to="{ name: 'EvaluatorsEmailOverview' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Evaluator Emails</router-link
            >
            <router-link
              :to="{ name: 'StaffEvaluatorReports' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Reports</router-link
            >
            <router-link
              :to="{ name: 'StaffEditPreferences' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Edit Preferences</router-link
            >
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable" v-if="user && user.is_staff">
          <a class="navbar-link">
            Submissions
          </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'SubmissionsOverview' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Submissions</router-link
            >
            <router-link
              :to="{ name: 'StaffSubmissionReports' }"
              class="navbar-item"
              v-if="user && user.is_staff && user.is_evaluator"
              >Reports</router-link
            >
          </div>
        </div>
      </div>
      <div class="navbar-end">
        <span @click="logout" class="navbar-item">Log Out</span>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['userLoggedInStatus', 'user']),
  },
  methods: {
    logout() {
      this.$store.commit('LOGOUT_USER')
      this.$router.push({ name: 'Login' })
    },
  },
}
</script>

<style scoped></style>
